export default "__VITE_ASSET__awGg7hOi__"